export function getDomainWithoutPort(url) {
    try {
        // Create a URL object
        const parsedUrl = new URL(url);

        // Reconstruct the URL without the port
        return `${parsedUrl.protocol}//${parsedUrl.hostname}`;
    } catch (error) {
        console.error('Invalid URL:', error);
        return null;
    }
}